import {
  SHOW_TURNTABLE,
  SET_TURNTABLE_SIZE,
  SET_RESULT_SELECTED,
  SET_CHOICES,
  SET_TYPE_ACTIVE,
  SET_TYPE_COUNT,
  SET_CATEGORY,
  SET_LEVEL,
  SET_HISTORY,
  SET_MODE,
  CHANGE_KEY_TEXT,
  SET_TITLE_OBJ,
  SET_MYSTERY_WHEEL_ON,
  SET_MYSTERY_RESULT_ON,
  UPDATE_MYSTERY_SETTINGS,
  SET_SCORES,
  SET_AUTO_ADD_COUNT,
} from './constants'
import { setStartRotate } from '../turntable/actions'
import { setDataStatus } from '../common/actions'

export const showTurntable = turntable => ({
  type: SHOW_TURNTABLE,
  payload: {
    turntable,
  },
})

export const setTurntableSize = size => ({
  type: SET_TURNTABLE_SIZE,
  payload: {
    size,
  },
})

export const setResultSelected = (
  result,
  resultIndex = -1,
  resultPieColor = null,
) => ({
  type: SET_RESULT_SELECTED,
  payload: {
    result,
    resultIndex,
    resultPieColor,
  },
})

export const setChoices =
  (choices, resetAngle = true) =>
  async (dispatch, getState) => {
    if (resetAngle) {
      const state = getState()
      const startAngle = state.settings.spinBehavior.randomStart
        ? 2 * Math.PI * Math.random()
        : 0
      dispatch(setStartRotate(startAngle))
    }
    dispatch(setChoicesAction(choices))
  }

export const setChoicesAction =
  (choices, nullTurntable = true) =>
  dispatch => {
    dispatch({
      type: SET_CHOICES,
      payload: {
        choices,
        nullTurntable,
      },
    })
    dispatch(setDataStatus('Modified', 'Inputs'))
  }

export const setTypeActive = typeActive => ({
  type: SET_TYPE_ACTIVE,
  payload: {
    typeActive,
  },
})

export const setTypeCount = typeCount => ({
  type: SET_TYPE_COUNT,
  payload: {
    typeCount,
  },
})

export const setCategory = category => ({
  type: SET_CATEGORY,
  payload: {
    category,
  },
})

export const setLevel = level => ({
  type: SET_LEVEL,
  payload: {
    level,
  },
})

export const setHistory = history => ({
  type: SET_HISTORY,
  payload: {
    history,
  },
})

export const setMode = mode => ({
  type: SET_MODE,
  payload: {
    mode,
  },
})

export const changeKeyText = () => ({
  type: CHANGE_KEY_TEXT,
})

export const setTitleActive = active => dispatch => {
  dispatch(setTitleObj({ active }))
}

export const setTitleText = text => dispatch => {
  dispatch(setTitleObj({ text }))
}

export const setTitleObj = obj => dispatch => {
  dispatch({
    type: SET_TITLE_OBJ,
    payload: {
      obj,
    },
  })
  dispatch(setDataStatus('Modified', 'Title & Desc.'))
}

export const setMysteryWheelOn = status => dispatch => {
  dispatch({
    type: SET_MYSTERY_WHEEL_ON,
    payload: {
      status,
    },
  })
  dispatch(setDataStatus('Modified', 'Mystery'))
}

export const setMysteryResultOn = status => dispatch => {
  dispatch({
    type: SET_MYSTERY_RESULT_ON,
    payload: {
      status,
    },
  })
  dispatch(setDataStatus('Modified', 'Mystery'))
}

export const updateMysterySettings =
  (mysteryWheelOn, mysteryResultOn) => async (dispatch, getState) => {
    try {
      const state = getState()
      const pastMysteryWheelOn = state.tdq.mysteryWheelOn
      dispatch({
        type: UPDATE_MYSTERY_SETTINGS,
        payload: {
          mysteryWheelOn,
          mysteryResultOn,
        },
      })
      // redraw wheel
      if (pastMysteryWheelOn !== mysteryWheelOn) {
        dispatch(showTurntable(null))
      }
    } catch (error) {
      console.log(error)
    }
  }

export const setScores =
  (scores, dataStatus = 'Modified') =>
  dispatch => {
    dispatch({
      type: SET_SCORES,
      payload: {
        scores,
      },
    })
    dispatch(setDataStatus(dataStatus, 'Scores'))
  }

export const setAutoAddCount = status => ({
  type: SET_AUTO_ADD_COUNT,
  payload: {
    status,
  },
})
